export default __webpack_public_path__ + "static/media/menu-coffee.ca7c5751.jpg";